module.exports = __webpack_public_path__ + "assets/search.47bce5c7.svg";